import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { ProjectState } from 'store/Project/ProjectTypes'

type UpdateOperationsFlagsArgs = {
  shallUpdateOperationsSummary?: boolean
  shallUpdateOperationsLogs?: boolean
  isExportingToErp?: boolean
  isNesting?: boolean
  isManufacturabilityCheckRunning?: boolean
  isImnooIntegrationWorkloadRunning?: boolean
  isEstimating?: boolean
}

export const updateOperationsFlags: CaseReducer<
  ProjectState,
  PayloadAction<UpdateOperationsFlagsArgs>
> = (state, action) => {
  state.projectOperations.isEstimating =
    action.payload.isEstimating ?? state.projectOperations.isEstimating

  state.projectOperations.isNesting =
    action.payload.isNesting ?? state.projectOperations.isNesting

  state.projectOperations.isExportingToErp =
    action.payload.isExportingToErp ?? state.projectOperations.isExportingToErp

  state.projectOperations.isManufacturabilityCheckRunning =
    action.payload.isManufacturabilityCheckRunning ??
    state.projectOperations.isManufacturabilityCheckRunning

  state.projectOperations.isImnooIntegrationWorkloadRunning =
    action.payload.isImnooIntegrationWorkloadRunning ??
    state.projectOperations.isImnooIntegrationWorkloadRunning

  state.projectOperations.shallUpdateSummary =
    action.payload.shallUpdateOperationsSummary ??
    state.projectOperations.shallUpdateSummary ??
    false

  state.projectOperations.shallUpdateOperations =
    action.payload.shallUpdateOperationsLogs ??
    state.projectOperations.shallUpdateOperations ??
    false
}
